 
 
 
 
 
 
/**
 * @ignore
 * This component generates HTML content based on provided options and data. Currently supported data type is search
 * result (either main result or entry point associated with POI result).
 * Content generated is split into following sections which visibility is configurable:
 * * 'name' - prints POI name with associated icon
 * * 'address' - prints address information
 * * 'coordinates' - prints coordinates (lat,lng) information
 * * 'entryPoint' - prints parent POI name and entry point type
 *
 */
define([
    'leaflet',
    'model/search/modelFactory',
    './details/entryPointContent',
    './details/nameContent',
    './details/addressContent',
    './details/coordinatesContent',
    './actions/actionsGenerator',
    './wrapable'
], function(
    L,
    modelFactory,
    entryPointContent,
    nameContent,
    addressContent,
    coordinatesContent,
    actionsGenerator,
    Wrapable
) {
    'use strict';
    var AREAS = {
        ENTRYPOINT: 'entryPoint',
        NAME: 'name',
        ADDRESS: 'address',
        COORDINATES: 'coordinates'
    };
    var ordering = Object.keys(AREAS).map(function(item) {
        return AREAS[item];
    });

    var defaultOptions = {
        name: true,
        address: true,
        coordinates: true,
        entryPoint: false
    };

    var classes = {
        content: 'tomtom-point-content',
        details: 'tomtom-point-content__details'
    };
    var ContentGenerator;

    function areaContentGenerator(area, data) {
        switch (area) {
        case AREAS.ENTRYPOINT :
            return entryPointContent(data.parent.poi, data.type);
        case AREAS.NAME :
            return data.poi ? nameContent(data.poi) : L.DomUtil.create('span');
        case AREAS.ADDRESS :
            return addressContent(data);
        case AREAS.COORDINATES :
            return coordinatesContent(data.position);
        default :
            return L.DomUtil.create('span');
        }
    }

    ContentGenerator = function(options) {
        this.options = options || defaultOptions;
    };

    /**
     * @ignore
     * @param {Object} data Either search result or entry point
     * @param {Object }additionalData Parent POI if 'data' param is entry point. If not, it's ignored.
     * @return {Wrapable}
     */
    ContentGenerator.prototype.generate = function(data, additionalData) {
        var result = L.DomUtil.create('div', classes.content),
            details = L.DomUtil.create('div', classes.details),
            modeledData = modelFactory(data, additionalData),
            actions;

        ordering.reduce(function(accumulator, area) {
            if (this.options[area]) {
                accumulator.appendChild(areaContentGenerator(area, modeledData));
            }
            return accumulator;
        }.bind(this), details);

        if (details.children.length) {
            result.appendChild(details);
        }

        if (this.options.actions) {
            actions = actionsGenerator(modeledData, this.options.actions);
            result.appendChild(actions.getHtmlElement());
        }

        return new Wrapable(result, function() {
            if (actions) {
                actions.wrap();
            }
        });
    };

    /**
     * @ignore
     * @param {Object} options
     * @param {Boolean} [options.name=true] A flag specifying if name area is printed
     * @param {Boolean} [options.coordinates=true] A flag specifying if coordinates area is printed
     * @param {Boolean} [options.address=true] A flag specifying if address area is printed
     * @param {Boolean} [options.entryPoint=false] A flag specifying if entry point area is printed
     * @param {Object} [options.actions] An object describing what type of actions should be created
     * @param {Object} [options.actions.routing] An object grouping routing actions configuration
     * @param {Boolean} [options.actions.routing.routeTo] A flag specifying if 'Route to' action should be generated.
     *     Coordinates for this action are taken from 'position' field associated with provided data object.
     * @param {Boolean} [options.actions.routing.routeFrom] A flag specifying if 'Route from' action should be
     *     generated. Coordinates for this action are taken from 'position' field associated with provided data object.
     * @param {Boolean} [options.actions.routing.routeToEntryPoint] A flag specifying if 'Route to' action for entry
     *     points should be generated. Coordinates for this action are taken from 'position' field associated with given
     *     entry point. If no entry point is available this action will not be generated.
     * @param {Boolean} [options.actions.routing.routeFromEntryPoint] A flag specifying if 'Route from' action entry
     *     points should be generated. Coordinates for this action are taken from 'position' field associated with given
     *     entry point. If no entry point is available this action will not be generated.
     * @param {Function} [options.actions.routing.onActionClick] 'click' event handler for all route actions. Most
     *     probably used for generating a route.
     * @param {Object} [options.actions.search] An object grouping search actions configuration
     * @param {Boolean} [options.actions.search.searchNearby] A flag specifying if 'NearBy' search action should be
     *     generated.
     * @param {Function} [options.actions.search.onActionClick] 'click' event handler for all search actions.
     * @param {Object} [options.actions.remove] An object specifying if 'Remove' action is generated.
     * @param {Function} [options.actions.remove.onActionClick] 'click' event handler for all 'Remove' action.
     *
     * @return {Wrapable}
     */

    return function(options) {
        var result = new ContentGenerator(options);
        return result.generate.bind(result);
    };

});



// WEBPACK FOOTER //
// ./services/popupContentGenerator/pointHTMLContentGenerator.js